import TSConstants from '../../../utils/TSConstants'
import React from 'react'
import { QuizzSkinI } from './default'
import './lclp.scss'

export default class LCLPSkin implements QuizzSkinI {
  replaceHomeLogo() {
    return (
      <>
        <img
          className="twic petard-2"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/petard2.png`}
        />
        <img
          className="twic feu-artifice-1"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/feudartifice1.png`}
        />
        <img
          className="logo logo-lp twic"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/gateau.png`}
          style={{ width: '60%' }}
        />
        <img
          className="twic feu-artifice-2"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/feudartifice2.png`}
        />
        <img
          className="twic petard-1"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/petard1.png`}
        />
      </>
    )
  }

  homeHeaderDecoration() {
    return (
      <>
        <img
          className="twic lclp-guirlande-gauche"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/guirlande_gauche.png`}
        />
        <img
          className="twic lclp-guirlande-droite"
          src={TSConstants.PLACEHOLDER_URL}
          data-src={`image:/cdm/kadow/img/lclp/guirlande_droite.png`}
        />
      </>
    )
  }

  skin(): number {
    return TSConstants.QUIZZ_SKIN_LEADER_PRICE_ANNIVERSARY
  }

  appendToBody(step: number) {
    return null
    // return step === QUIZZ_STEP_HOME ? <Fireworks /> : null
  }
}
